import "./saveCalculationButton.scss";
import { Button } from "@material-ui/core";
import React from "react";
import SaveIcon from "@material-ui/icons/Save";

interface SaveCalculationButtonProps {
  onClick: (event: any) => void;
  disabled?: boolean;
}

export default function SaveCalculationButton(props: SaveCalculationButtonProps) {
  return (
    <div className="save-button-wrapper">
      <Button variant="contained" endIcon={<SaveIcon />}
        className="save-calculation-button"
        onClick={props.onClick}
        disabled={props.disabled}
      >
        Zapisz kalkulację
      </Button>
    </div>
  );
}
